import produce from 'immer';
import { TTopMarkets, TTopMarketsStore } from './types';
import {
  ArchieStateInitializer,
  StateCreator,
  createArchieStoreCreator,
  createHook,
} from '@awning/archie';
import { BUCKETS } from '@/src/Pagination';

type ImmerSet<T extends TTopMarketsStore> = (
  config: ArchieStateInitializer<T>
) => ArchieStateInitializer<T>;
const _set: ImmerSet<TTopMarketsStore> = config => (set, get, api) =>
  config(
    //@ts-ignore
    (partial, replace) => {
      const nextState = typeof partial === 'function' ? produce(partial) : partial;
      return set(nextState, replace);
    },
    get,
    api
  );

const stateInitializer: StateCreator<TTopMarketsStore> = _set(set => ({
  q: '',
  topMarkets: [] as TTopMarkets,
  range: BUCKETS?.[0],

  updateRange: (start, end) => {
    // @ts-expect-error
    set(state => {
      state.range[0] = start;
      state.range[1] = end;
    });
  },
}));

export const topMarketsStoreCreator = createArchieStoreCreator({
  name: 'topMarketsStore',
  stateInitializer,
});

export const useTopMarketsStore = createHook(topMarketsStoreCreator);
